module.exports = __webpack_public_path__ + "img/6.05620bc6.png";